import { Panels } from "../lib/Panels.mjs";
Panels.init();

const elLightbox = document.getElementById('lightbox-modal');
const lightboxModal = new bootstrap.Modal(elLightbox, {});
const lightboxModalContent = document.getElementById('lightbox-container');

document.querySelectorAll(".content-grid-pictures, .lightbox-pictures").forEach(imageGrid =>{
  const links = Array.from(imageGrid.querySelectorAll("a"));

  links.forEach((it, i) => it.addEventListener("click", ev =>{
    ev.preventDefault();

    lightboxModalContent.innerHTML = `<div id="lightbox" class="carousel slide carousel-fade carousel-dark">
<div class="carousel-indicators">
${links.map((it, ii) => {
    return `<button type="button" data-bs-target="#lightbox" ${(ii===i)? 'class="active" aria-current="true"':' '} data-bs-slide-to="${ii}" aria-label="Slide ${ii}"></button>`
}).join('\n')}
</div>
<div class="carousel-inner">
${links.map((it, ii)=>{
  const caption = it.querySelector('.caption')?.innerHTML || "";
  const description = it.querySelector('.description')?.innerHTML || "";
    return `<div class="carousel-item ${(ii===i)? 'active':''}" style="background-image:url('${it.getAttribute('href')}')"><div class="message ${((caption + description) === "")? "d-none": ""}"><div class="caption">${caption}</div><div class="description">${description}</div></div></div>`
}).join('\n')}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#lightbox" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#lightbox" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>`;

    const c = new bootstrap.Carousel(document.getElementById('lightbox'),{
      keyboard: true,
    });

    lightboxModal.show();
    c.to(i);
    c.pause();
    return false;
  }));
});